export default __webpack_public_path__ + "static/media/home-decor-img-01.e11071f0.png";